/* es5-ext/string/#/contains/is-implemented */ function _(require, module, exports) {
    var str = "razdwatrzy";
    module.exports = function () {
        if (typeof str.contains !== "function")
            return false;
        return (str.contains("dwa") === true) && (str.contains("foo") === false);
    };
}
